import { Column } from "@tanstack/react-table"

import {
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
} from "../../DropdownMenu"

export function BooleanFilter<T extends Record<string, any> = object>({
  col,
  filterValue,
}: {
  col: Column<T>
  filterValue?: boolean
}) {
  const label = col.columnDef.meta?.textLabel ?? col.columnDef.header
  if (typeof label !== "string") {
    throw new Error(
      "column `header` must be a string, or `meta.textLabel` must be set.",
    )
  }

  return (
    <>
      <DropdownMenuLabel>{label}</DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuRadioGroup value={String(filterValue)}>
        {(
          [
            [true, "Yes"],
            [false, "No"],
          ] as const
        ).map(([value, label]) => (
          <DropdownMenuRadioItem
            key={label}
            value={String(value)}
            onSelect={(event) => {
              event.preventDefault()
              col.setFilterValue(filterValue !== value ? value : undefined)
            }}
          >
            {label}
          </DropdownMenuRadioItem>
        ))}
      </DropdownMenuRadioGroup>
    </>
  )
}
